export default __webpack_public_path__ + "static/media/sale.5f74098f.jpg";